module.exports = __webpack_public_path__ + "static/img/t-2-error-miss-mobile.796470e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/StranNeObstaja/t-2-error-miss-mobile.png
// module id = bet0
// module chunks = 3